import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  button: {
    padding: 8,
  },

  header: {
    fontSize: "2rem",
    fontWeight: 700,
  },
}));

const ColumnHeader = ({
  buttonText,
  customButton = null,
  header,
  onClick,
  paddingBottom = "24px",
}) => {
  const classes = useStyles();
  return (
    <Grid
      container
      item
      justify="space-between"
      alignItems="center"
      style={{ paddingBottom: paddingBottom }}
    >
      <header>
        <Typography variant="h6">{header}</Typography>
      </header>

      {customButton ? (
        customButton
      ) : onClick ? (
        <Button
          className={classes.button}
          variant="outlined"
          color="primary"
          onClick={onClick}
        >
          {buttonText}
        </Button>
      ) : null}
    </Grid>
  );
};

export default ColumnHeader;
